module.exports = __webpack_public_path__ + "202388/img/avatar.f57ebce8.png";